var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.blockClasses,on:{"click":_setup.handleClick}},[_c('div',{ref:"dropdownRef",staticClass:"vac-dropdown__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }